import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=217992f4&scoped=true"
import script from "./SettingModal.vue?vue&type=script&lang=js"
export * from "./SettingModal.vue?vue&type=script&lang=js"
import style0 from "./SettingModal.vue?vue&type=style&index=0&id=217992f4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217992f4",
  null
  
)

export default component.exports